module.exports = __webpack_public_path__ + "static/media/11.597e9afa.mp3";